import { useCallback, useState } from 'react'
import { KonvaEventObject } from 'konva/lib/Node'
import { BaseElementBounds, BaseElementData } from '../models/Construction'
import {
  ElementInteractionCallbacks,
  ResizeMode,
} from '../components/viewer/2D/Elements'

export const useElementBehaviors = <T extends BaseElementData>(
  element: T,
  bounds: BaseElementBounds,
  callbacks?: ElementInteractionCallbacks<T>,
) => {
  const [isHovered, setIsHovered] = useState(false)

  const handleClick = useCallback(
    (e: KonvaEventObject<MouseEvent>) => {
      e.cancelBubble = true
      callbacks?.onSelect?.(element)
    },
    [element, callbacks],
  )

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false)
  }, [])

  const handleResizeStart = useCallback(
    (mode: ResizeMode, e: KonvaEventObject<MouseEvent>) => {
      // e.cancelBubble = true;
      // const pos = e.target.getStage()?.getPointerPosition();
      // if (pos && callbacks?.onResizeStart) {
      //   callbacks.onResizeStart(element.id, 'element', mode, { x: pos.x, y: pos.y }, bounds);
      // }
    },
    [element.id, bounds, callbacks],
  )

  const handleDelete = useCallback(() => {
    callbacks?.onDelete?.(element.id, element.type)
  }, [element.id, callbacks])

  return {
    isHovered,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleResizeStart,
    handleDelete,
  }
}
